<template>
  <div>
    <h1 v-html="modelValue.Content.StepThree.Title" />
    <section>
      <article class="flow-group row push-down">
        <div class="control">
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.ContentInsuranceToTerminateTooltip"
            :h3="modelValue.Content.StepThree.ContentInsuranceToTerminateLabel"
            class="small-12 columns"
          />
          <div class="small-12 medium-9 columns">
            <Field
              name="hascontentinsurancetoterminate"
              :model-value="studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate"
              :rules="'required'"
            >
              <base-radio-buttons-stacked-study
                v-for="(option, index) in modelValue.Content.StepThree.InsuranceToTerminateOptions"
                :key="index"
                v-model="studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate"
                :option="option"
                :index="index"
                name="hascontentinsurancetoterminate"
                @update:model-value="hasContentInsuranceChangeHandle"
              />
            </Field>
            <ValidationError
              name="hascontentinsurancetoterminate"
              :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              mode="lazy"
            />
          </div>
        </div>
        <div
          v-if="studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate === 1"
          class="control small-12 columns push-up push-down"
        >
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.InsuranceToTerminateCompanyTooltip"
            :h3="modelValue.Content.StepThree.InsuranceToTerminateCompanyLabel"
          />
          <Field
            :model-value="studyInsuranceSubmitTemplate.Content_CompanyToTerminateInsuranceIn"
            :rules="'required'"
            name="study-content-insurance-company"
          >
            <VueSelect
              v-model="studyInsuranceSubmitTemplate.Content_CompanyToTerminateInsuranceIn"
              name="study-content-insurance-company"
              :options="modelValue.Content.StepThree.InsuranceToTerminateCompanyOptions"
              label="Name"
            />
          </Field>
          <ValidationError
            name="study-content-insurance-company"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
          <info-box
            v-if="studyInsuranceSubmitTemplate.Content_CompanyToTerminateInsuranceIn === null"
            :text="modelValue.Content.StepThree.InsuranceToTerminateCompanyInfoBox"
            name="study-content-company-info-box"
          />
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.ContentStartDateTooltip"
            :h3="modelValue.Content.StepThree.ContentStartDateLabel"
            class="push-up"
          />
          <div class="row push-up">
            <div class="small-12 medium-10 columns">
              <Field
                :model-value="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate"
                name="contentinsurancetoterminatestartdate"
                :rules="'required'"
              >
                <base-radio-buttons-stacked-study
                  v-for="(option, index) in modelValue.Content.StepThree.StartDateOptions"
                  :key="index"
                  v-model="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate"
                  :option="option"
                  :index="index"
                  name="contentinsurancetoterminatestartdate"
                />
              </Field>
              <ValidationError
                name="contentinsurancetoterminatestartdate"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
                mode="lazy"
              />
              <info-box
                v-if="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate === 1"
                :text="modelValue.Content.StepThree.StartDateInfoBox"
                name="study-content-startdate-info-box"
              />
            </div>
          </div>
          <div v-if="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate === 2">
            <h-3-and-tooltip
              :tooltip="modelValue.Content.StepThree.ExpirationDateTooltip"
              :h3="modelValue.Content.StepThree.ExpirationDateLabel"
            />
            <Field
              :model-value="studyInsuranceSubmitTemplate.Content_ExpirationDateOnCurrentInsurance"
              name="study-content-expiration-date"
              :rules="'required'"
            >
              <VueSelect
                v-model="studyInsuranceSubmitTemplate.Content_ExpirationDateOnCurrentInsurance"
                :options="modelValue.Content.StepThree.ExpirationDates"
                name="study-content-expiration-date"
                label="Name"
              />
            </Field>
            <ValidationError
              name="study-content-expiration-date"
              :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              mode="lazy"
            />
          </div>
          <div class="push-up">
            <h-3-and-tooltip
              :tooltip="modelValue.Content.StepThree.TravelInsuranceToTerminateTooltip"
              :h3="modelValue.Content.StepThree.TravelInsuranceToTerminateLabel"
            />
            <div class="row">
              <Field
                :rules="'required'"
                :model-value="studyInsuranceSubmitTemplate.Travel_HasInsuranceToTerminate"
                name="traveltoterminate"
              >
                <div
                  v-for="(option, index) in modelValue.Content.StepThree
                    .TravelInsuranceToTerminateOptions"
                  :key="index"
                  class="small-6 columns"
                >
                  <base-radio-buttons-stacked-study
                    v-model="studyInsuranceSubmitTemplate.Travel_HasInsuranceToTerminate"
                    :option="option"
                    :index="index"
                    name="traveltoterminate"
                  />
                </div>
              </Field>
              <div class="small-12 columns">
                <ValidationError
                  name="traveltoterminate"
                  :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
                  mode="lazy"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate === 3"
          class="small-12 columns push-up"
        >
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.ContentStartDateTooltip"
            :h3="modelValue.Content.StepThree.ContentStartDateLabel"
          />
          <Field
            :model-value="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate"
            name="study-content-date-picker"
            :rules="{ required: true }"
          >
            <date-picker
              id="study-content-date-picker"
              v-model="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate"
              name="study-content-date-picker"
              :date="studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate"
              :min-date="todayDate"
              :max-date="todayPlusOneYearDate"
              placeholder="Udfyld venligst"
              class="datepicker"
              display-format="DD-MM-YYYY"
              save-format="DD-MM-YYYY"
              @update:model-value="
                studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate = $event;
                dateChanged($event, 'Content_NewInsuranceStartDate');
              "
            />
          </Field>
          <ValidationError
            name="study-content-date-picker"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
        </div>

        <hr class="small-12 columns" />

        <div class="control push-up">
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.AccidentInsuranceToTerminateTooltip"
            :h3="modelValue.Content.StepThree.AccidentInsuranceToTerminateLabel"
            class="small-12 columns"
          />
          <div class="small-12 medium-9 columns">
            <Field
              :model-value="studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate"
              name="hasaccidentinsurancetoterminate"
              :rules="'required'"
            >
              <base-radio-buttons-stacked-study
                v-for="(option, index) in modelValue.Content.StepThree.InsuranceToTerminateOptions"
                :key="index"
                v-model="studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate"
                :option="option"
                :index="index"
                name="hasaccidentinsurancetoterminate"
                @update:model-value="hasAccidentInsuranceChangeHandle"
              />
            </Field>
            <ValidationError
              name="hasaccidentinsurancetoterminate"
              :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              mode="lazy"
            />
          </div>
        </div>
        <div
          v-if="studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate === 1"
          class="control small-12 columns"
        >
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.InsuranceToTerminateCompanyTooltip"
            :h3="modelValue.Content.StepThree.InsuranceToTerminateCompanyLabel"
          />
          <Field
            :model-value="studyInsuranceSubmitTemplate.Accident_CompanyToTerminateInsuranceIn"
            :rules="'required'"
            name="study-accident-insurance-company"
          >
            <VueSelect
              v-model="studyInsuranceSubmitTemplate.Accident_CompanyToTerminateInsuranceIn"
              :options="modelValue.Content.StepThree.InsuranceToTerminateCompanyOptions"
              name="study-accident-insurance-company"
              label="Name"
            />
          </Field>
          <ValidationError
            name="study-accident-insurance-company"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
          <info-box
            v-if="studyInsuranceSubmitTemplate.Accident_CompanyToTerminateInsuranceIn === null"
            :text="modelValue.Content.StepThree.InsuranceToTerminateCompanyInfoBox"
            name="study-accident-company-info-box"
          />
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.AccidentStartDateTooltip"
            :h3="modelValue.Content.StepThree.AccidentStartDateLabel"
          />
          <div class="row">
            <div class="small-12 medium-10 columns">
              <Field
                name="accidentinsurancetoterminatestartdate"
                :model-value="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate"
                :rules="'required'"
              >
                <base-radio-buttons-stacked-study
                  v-for="(option, index) in modelValue.Content.StepThree.StartDateOptions"
                  :key="index"
                  v-model="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate"
                  :option="option"
                  :index="index"
                  name="accidentinsurancetoterminatestartdate"
                />
              </Field>
              <ValidationError
                name="accidentinsurancetoterminatestartdate"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
                mode="lazy"
              />
              <info-box
                v-if="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate === 1"
                :text="modelValue.Content.StepThree.StartDateInfoBox"
                name="study-accident-startdate-info-box"
              />
            </div>
          </div>
          <div v-if="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate === 2">
            <h-3-and-tooltip
              :tooltip="modelValue.Content.StepThree.ExpirationDateTooltip"
              :h3="modelValue.Content.StepThree.ExpirationDateLabel"
            />
            <Field
              :model-value="studyInsuranceSubmitTemplate.Accident_ExpirationDateOnCurrentInsurance"
              :rules="'required'"
              name="study-accident-expiration-date"
            >
              <VueSelect
                v-model="studyInsuranceSubmitTemplate.Accident_ExpirationDateOnCurrentInsurance"
                :options="modelValue.Content.StepThree.ExpirationDates"
                label="Name"
                name="study-accident-expiration-date"
              />
            </Field>
            <ValidationError
              name="study-accident-expiration-date"
              :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              mode="lazy"
            />
          </div>
        </div>
        <div
          v-if="studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate === 3"
          class="small-12 columns push-up"
        >
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepThree.AccidentStartDateTooltip"
            :h3="modelValue.Content.StepThree.AccidentStartDateLabel"
          />
          <Field
            name="study-accident-date-picker"
            :rules="'required'"
            :model-value="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate"
          >
            <date-picker
              v-model="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate"
              id="study-accident-date-picker"
              name="study-accident-date-picker"
              :date="studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate"
              :min-date="todayDate"
              :max-date="todayPlusOneYearDate"
              placeholder="Udfyld venligst"
              class="datepicker"
              display-format="DD-MM-YYYY"
              save-format="DD-MM-YYYY"
              @update:model-value="
                studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate = $event;
                dateChanged($event, 'Accident_NewInsuranceStartDate');
              "
            />
          </Field>
          <ValidationError
            name="study-accident-date-picker"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import moment from 'moment';
import Utility from '@/common/UtilityFunctions.js';
import StudyMixin from './StudyMixin.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import InfoBox from '@/components/UI/InfoBox.vue';
import BaseRadioButtonsStackedStudy from './BaseRadioButtonsStackedStudy.vue';
import DatePicker from '@/components/UI/Pickadate.vue';

export default {
  name: 'AdditionalInfoStudy',
  components: {
    H3AndTooltip,
    BaseRadioButtonsStackedStudy,
    DatePicker,
    InfoBox
  },
  emits: ['update:modelValue'],
  mixins: [StudyMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    },
    localModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      travelInsuranceToTerminate: false
    };
  },
  computed: {
    studyInsuranceSubmitTemplate: {
      get() {
        if (Object.prototype.hasOwnProperty.call(this.modelValue, 'Data')) {
          return this.modelValue.Data.StudyInsuranceSubmitTemplate;
        }
        return {};
      },
      set(val) {
        const tmp = { ...this.modelValue };
        tmp.Data.StudyInsuranceSubmitTemplate = val;
        this.$emit('update:modelValue', tmp);
      }
    },
    todayDate() {
      return moment();
    },
    todayPlusOneYearDate() {
      return moment().add(1, 'year');
    }
  },
  watch: {
    'studyInsuranceSubmitTemplate.StepThreeContent.HasInsuranceToTerminate': function (val) {
      if (val === 2) {
        this.showContactModal();
      }
    },
    'studyInsuranceSubmitTemplate.StepThreeAccident.HasInsuranceToTerminate': function (val) {
      if (val === 2) {
        this.showContactModal();
      }
    }
  },
  mounted() {
    Utility.pushToTagManager({
      event: 'track-ga-vp',
      virtualPath: '/virtual/studie-prisberegner-03-supplerende-oplysninger',
      virtualTitle: 'Virtuel - Beregn pris - Studie - supplerende-oplysninger'
    });
  },
  methods: {
    hasContentInsuranceChangeHandle() {
      this.studyInsuranceSubmitTemplate.Content_NewInsuranceStartDate = null;
      this.studyInsuranceSubmitTemplate.Content_ExpirationDateOnCurrentInsurance = null;
      this.studyInsuranceSubmitTemplate.Content_CompanyToTerminateInsuranceIn = null;
      this.studyInsuranceSubmitTemplate.Travel_HasInsuranceToTerminate = null;
    },
    hasAccidentInsuranceChangeHandle() {
      this.studyInsuranceSubmitTemplate.Accident_NewInsuranceStartDate = null;
      this.studyInsuranceSubmitTemplate.Accident_ExpirationDateOnCurrentInsurance = null;
      this.studyInsuranceSubmitTemplate.Accident_CompanyToTerminateInsuranceIn = null;
    },
    dateChanged(param, prop) {
      this.studyInsuranceSubmitTemplate[prop] = moment(param, 'DD-MM-YYYY').format();    }
  }
};
</script>
